/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateVesselInput = {
    clientMutationId?: string | null;
    slug: string;
    name: string;
    shippingLineSlug: string;
    imoNumber?: string | null;
};
export type VesselEditMutationVariables = {
    input: infoUpdateVesselInput;
};
export type VesselEditMutationResponse = {
    readonly infoUpdateVessel: {
        readonly vessel: {
            readonly slug: string;
        };
    } | null;
};
export type VesselEditMutation = {
    readonly response: VesselEditMutationResponse;
    readonly variables: VesselEditMutationVariables;
};



/*
mutation VesselEditMutation(
  $input: infoUpdateVesselInput!
) {
  infoUpdateVessel(input: $input) {
    vessel {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VesselEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateVesselPayload",
        "kind": "LinkedField",
        "name": "infoUpdateVessel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vessel",
            "kind": "LinkedField",
            "name": "vessel",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VesselEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateVesselPayload",
        "kind": "LinkedField",
        "name": "infoUpdateVessel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vessel",
            "kind": "LinkedField",
            "name": "vessel",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "221a2660a84447ccb71d4a25396ca549",
    "id": null,
    "metadata": {},
    "name": "VesselEditMutation",
    "operationKind": "mutation",
    "text": "mutation VesselEditMutation(\n  $input: infoUpdateVesselInput!\n) {\n  infoUpdateVessel(input: $input) {\n    vessel {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0ff2e7b80b0f7deb78a3c4696fc83ea4';
export default node;
